
import PostList from '../components/PostList';

export default function Home() {
  return (
    <main>
      <PostList />
    </main>
  );
}
